const namespace = "connectionError";

export const RETRY = `${namespace}.retry`;
export const CLOSE = `${namespace}.close`;
